<template>
    <button class="print btn btn-primary hidden-print" @click="print" :class="{inline: inline}">
        <span class="fa fa-print fa-fw"></span>&nbsp;
        Print
    </button>
</template>

<style lang="scss">
    .print {
        &.inline {
            float: left;
        }
    }
</style>

<script>
export default {
    props: {
        inline: {
            type: Boolean,
            default: true
        }
    },

    methods: {
        print() {
            window.print()
        }
    }
}
</script>


// WEBPACK FOOTER //
// Print.vue?73f472e1